import React from 'react';
import HeroSection from '../components/sections/HeroSection.tsx';

const LandingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-primary">
      <HeroSection />
    </div>
  );
};

export default LandingPage;
